import { useState } from "react";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { MarqueeStrip, CapabilityStrip, FeatureGrid, WarehouseViz } from "@/components/site/Sections";
import { MasterPlanner, PalletControl, OperatorConsole, ThreePL } from "@/components/site/Modules";
import { Pricing, ROICalculator, Testimonials } from "@/components/site/Conversion";
import { HealthCheck } from "@/components/site/HealthCheck";
import { DemoForm } from "@/components/site/DemoForm";
import { FinalCTA, Footer } from "@/components/site/Footer";

export default function Landing() {
  const [demoOpen, setDemoOpen] = useState(false);
  const openDemo = () => setDemoOpen(true);
  const scrollToFeatures = () => document.querySelector("#features")?.scrollIntoView({ behavior: "smooth" });

  return (
    <div data-testid="landing-page">
      <Navbar onBookDemo={openDemo} />
      <main>
        <Hero onBookDemo={openDemo} onExplore={scrollToFeatures} />
        <MarqueeStrip />
        <CapabilityStrip />
        <FeatureGrid />
        <WarehouseViz />
        <MasterPlanner />
        <PalletControl />
        <OperatorConsole />
        <ThreePL />
        <HealthCheck />
        <ROICalculator />
        <Pricing onBookDemo={openDemo} />
        <Testimonials />
        <FinalCTA onBookDemo={openDemo} />
      </main>
      <Footer />
      <DemoForm open={demoOpen} onClose={() => setDemoOpen(false)} />
    </div>
  );
}
